import { useEffect, useState } from "react";
import { SpeedbackSession, Member, Rounds } from "speedback-session";
import { LayoutWithTeamExistanceChecker  } from "../layout";
import { useTeam } from "../team-members/team-member-context";

export function SpeedBack() {
  const { teamMembers } = useTeam();
  const [rounds, setRounds] = useState<Rounds[]>([]);

  useEffect(() => {
    const members: Member[] = teamMembers.map(item => ({ id: item.id, name: item.name }))
    const speedback = new SpeedbackSession(members);

    if (members.length) {
      setRounds(speedback.generateRounds());
    }
  }, [teamMembers, teamMembers.length]);

  return (
    <LayoutWithTeamExistanceChecker>
      {rounds.map((round: Rounds, index) =>
        <div
          key={`${round.roundNumber}-${index}`}
          data-testid="rounds"
        >
          <h2 className="text-2xl pt-5">round {round.roundNumber}</h2>
          {round.pairs.map((pairs) => {
            return (
              <p key={`${pairs[0].id}-${pairs[1].id}`}>{pairs[0].name} + {pairs[1].name }</p>
            )
          })}
        </div>
      )}
    </LayoutWithTeamExistanceChecker>
  );
}